var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Finder, FinderHeader, FinderTitle, FinderBody, NavPath } from "../";
import { InboxResults, InboxEditor } from "../";

var LayoutInbox = (_temp2 = _class = function (_Component) {
    _inherits(LayoutInbox, _Component);

    function LayoutInbox() {
        var _temp, _this, _ret;

        _classCallCheck(this, LayoutInbox);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderHeader = function () {
            var _this$props = _this.props,
                title = _this$props.title,
                parents = _this$props.parents;


            if (parents) {

                return React.createElement(
                    FinderHeader,
                    null,
                    React.createElement(NavPath, { parents: parents })
                );
            }

            return React.createElement(
                FinderHeader,
                null,
                React.createElement(FinderTitle, { title: title })
            );
        }, _this.renderBody = function () {
            var _this$props2 = _this.props,
                results = _this$props2.results,
                item = _this$props2.item;


            var style = {
                paddingLeft: 0,
                paddingRight: 0
            };

            if (_this.props.children) {

                return React.createElement(
                    FinderBody,
                    { style: style },
                    _this.props.children
                );
            }

            if (item && item.uniqueId) {

                return React.createElement(
                    FinderBody,
                    { style: style },
                    React.createElement(InboxEditor, _extends({}, _this.props, { formData: item }))
                );
            }

            if (results) {
                return React.createElement(
                    FinderBody,
                    { style: style },
                    React.createElement(InboxResults, _extends({}, _this.props, { results: results }))
                );
            }

            return React.createElement(
                FinderBody,
                { style: style },
                _this.props.children
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    LayoutInbox.prototype.render = function render() {

        return React.createElement(
            Finder,
            null,
            this.renderHeader(),
            this.renderBody()
        );
    };

    return LayoutInbox;
}(Component), _class.defaultProps = {}, _temp2);
LayoutInbox.propTypes = process.env.NODE_ENV !== "production" ? {
    /** Title */
    title: PropTypes.string,
    /** Parents */
    parents: PropTypes.array,
    /** Section */
    section: PropTypes.string,
    /** Category */
    category: PropTypes.string,
    /** Results */
    results: [],
    /** FormData */
    item: {}
} : {};


export default LayoutInbox;